export default __webpack_public_path__ + "static/media/1192.9856e90f.jpg";